import React, { useState } from 'react';


const Project = ({ project, setViewHtmlDetails }) => {
    const badge = [' badge-primary', 'badge-secondary', 'badge-accent']
    const ProjectsData = [
        {
            name: 'Car Manufacturer',
            img: 'https://i.ibb.co/vjvrZj9/screencapture-car-manufacturer-df280-web-app-2022-06-10-21-55-58.png',
            technology: ['Firebase', "React", "NodeJs", "ExpressJS", "Mongodb", "Tailwind"],
            link: {
                live: 'https://car-manufacturer-df280.web.app/',
                github: 'https://github.com/SRAKIB17/manufacturer-website-client-side-SRAKIB17',
                githubServer: 'https://github.com/SRAKIB17/manufacturer-website-server-side-SRAKIB17'
            },
            html: ``,
            new: 'new'
        }]

    const { name, img, technology, link, html, new: newP } = project;

    return (
        <div>
            <div className="card w-full  sm:w-96 bg-base-100 shadow-xl">
                <figure><img src={img} alt="Shoes" className='w-full sm:w-[400px] h-[200px]' /></figure>
                <div className="card-body">
                    <h2 className="card-title">
                        {name}
                        {
                            newP && <div className="badge badge-secondary">new</div>
                        }
                    </h2>
                    <div className="card-actions justify-end">
                        {
                            technology?.map((tec, i) => <div key={i} class={"badge " + badge[Math.floor(Math.random() * badge.length)]}>{tec}</div>)
                        }
                    </div>
                    <div className="flex justify-between items-center mt-1 gap-1">

                        {
                            link?.live && <a href={link?.live} className="btn btn-outline btn-xs" target='_blank' rel="noreferrer">Live</a>
                        }
                        {
                            link?.github && <a href={link?.github} className="btn btn-outline btn-xs" target='_blank' rel="noreferrer">GitHub</a>
                        }
                        {
                            link?.githubServer && <a href={link?.githubServer} className="btn  btn-outline btn-xs" target='_blank' rel="noreferrer">Server</a>
                        }
                        <div>
                            <label onClick={() => setViewHtmlDetails(project)} htmlFor="veiwDetails" className="btn mt-1 btn-xs btn-outline">View Details</label>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
};

export default Project;
